import { Fragment, Key, ReactNode } from 'react';
import customIcons from '../../utils/icons';
import SkeletonCard from './skeletonCard';

type CardContainerProps<T> = {
  data: T[] | null;
  error: Error | null;
  loading: boolean;
  getKey: (item: T) => Key;
  renderItem: (item: T) => ReactNode;
};

const fallbackCards = ['first', 'second', 'third', 'fourth'];

export default function CardContainer<T>({
  data, error, loading, getKey, renderItem
}: CardContainerProps<T>) {
  if (loading || !data) {
    return fallbackCards.map((card) => <SkeletonCard key={card} />);
  }

  if (error) {
    return fallbackCards.map((card) => (
      <div key={`error-card-${card}`} className="flex flex-col justify-center items-center grow min-w-37.5 flex-1 card font-normal">
        <span title={error.message} className="text-2xl text-pipstatus-alert">{customIcons.errorIcon}</span>
      </div>
    ));
  }

  return data?.map((card) => (
    <Fragment key={getKey(card)}>
      {renderItem(card)}
    </Fragment>
  ));
}
